import axios from "axios";
import { t } from "i18next";
import _ from "lodash";

import ls from "local-storage";

import UniversityApi from "./university-api";

import AlertsService from "services/alerts-service";
import { getToken, handleError, removeToken, setToken } from "services/api-service";

import { clearStorage, getStorage, putStorage } from "hooks/useStorage";

import { ERoles } from "types/enums";

function gup(name) {
    let url = window.location.href;
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regexS = "[\\?&]" + name + "=([^&#]*)";
    var regex = new RegExp(regexS);
    var results = regex.exec(url);
    return results == null ? null : results[1];
}

type Notification = {
    type: "warning" | "danger" | "info";
    text: string;
    name: string;
    timestamp: number;
    refLink?: string;
};

const UserApi = {
    signup: async (data: any) => {
        try {
            const { data: response } = (await axios.post("/users/signup", _.pick(data, [`email`, `password`, `referralUserId`]))) as any;
            setToken(response?.token);
            await UserApi.updateUser(_.pick(data, [`name`, `phone`, `studentRoleType`, `userUniversityId`]));
            return response;
        } catch (error) {
            throw AlertsService.showError(t("u0crwcneoh8"));
        }
    },
    login: async (data: { email: string; password: string; [key: string]: string }) => {
        try {
            const { data: response } = (await axios.post("/users/login", data)) as any;
            setToken(response?.token);
            await UserApi.getCurrentUser();
            return response;
        } catch (error) {
            throw AlertsService.showError(t("5pavhj2lepw"));
        }
    },
    logout: () => {
        console.log('-> logout');
        try {
            removeToken();
            clearStorage([`initialized`]);
            // @ts-ignore
            ls.remove("admin_mode");
            return true;
        } catch (error) {
            throw AlertsService.showError(t("kir24zpf6m"));
        }
    },
    getCurrentUser: async () => {
        if (gup("auth_token") != undefined) {
            setToken(gup("auth_token"));
            try {
                ls("admin_mode", "yes");
            } catch (exc) {

            }
        } else {
            try {
//                @ts-ignore
//                 ls.remove("admin_mode");
            } catch (exc1) {

            }
        }
        try {
            if (!getToken()) {
                removeToken();
                return;
            }
            const { data: response = {} } = (await axios.get("/me")) as any;
            console.log("current user response", response);
            // @ts-ignore
            window.currentUser = response;
            if (response?.userRole === ERoles.University || response?.userRole === ERoles.ClubsUniAdmin) {
                await UniversityApi.getMyUniversity();
            }
            putStorage(`user`, response);
            return response;
        } catch (error) {
            removeToken();
            handleError(error);
        } finally {
            setTimeout(() => putStorage(`initialized`, true), 0);
        }
    },
    updateUser: async (data: any) => {
        try {
            const { data: response } = (await axios.put("/users", data)) as any;
            await UserApi.getCurrentUser();
            return response;
        } catch (error) {
            throw AlertsService.showError(t("i99hdutqy6"));
        }
    },
    getUniToken: async (uniId: string) => {
        try {
            const { data: response } = (await axios.get(`/uni/${uniId}/token`)) as any;
            return response.token;
        } catch (error) {
            throw AlertsService.showError(t("l2yswoi5uui"));
        }
    },
    getUserByRecoveryKey: async (key: string) => {
        try {
            const { data: response } = (await axios.get(`/recover/${key}`)) as any;
            return response;
        } catch (error) {
            throw AlertsService.showError(t("55v34be5n1s"));
        }
    },
    resetPassword: async (key: string, password: string) => {
        try {
            const { data: response } = (await axios.post(`/users/recover/${key}`, { password: password })) as any;
            return response;
        } catch (error) {
            throw AlertsService.showError(t("0xzy1g5evlt"));
        }
    },
    createPasswordRecoveryIntent: async (email: string) => {
        try {
            const { data: response } = (await axios.post(`/users/recover`, { email: email })) as any;
            return response;
        } catch (error) {
            throw AlertsService.showError(t("ney0gjzh91l"));
        }
    },
    toggleDormitoryStar: async (dormitoryId: string) => {
        try {
            const oldUser = getStorage(`user`);
            const isStarred = (oldUser?.starredDormitories || [])?.includes(dormitoryId);
            oldUser.starredDormitories = [...(oldUser.starredDormitories || []), dormitoryId].filter((i) => (i === dormitoryId ? !isStarred : true));
            const { data: response } = (await axios.put("/users", oldUser)) as any;
            await UserApi.getCurrentUser();
            return response;
        } catch (error) {
            throw AlertsService.showError(t("xosuncgtif"));
        }
    },
    toggleEventStar: async (eventId: string) => {
        try {
            const oldUser = getStorage(`user`);
            const isStarred = (oldUser?.starredEvents || [])?.includes(eventId);
            oldUser.starredEvents = [...(oldUser.starredEvents || []), eventId].filter((i) => (i === eventId ? !isStarred : true));
            const { data: response } = (await axios.put("/users", oldUser)) as any;
            await UserApi.getCurrentUser();
            return response;
        } catch (error) {
            throw AlertsService.showError(t("ozyoant4v9"));
        }
    },
    getNotifications: async (): Promise<Notification[]> => {
        try {
            const { data: response } = (await axios.get(`/notifications`)) as any;
            putStorage(`notifications`, response);
            return response;
        } catch (error) {
            throw AlertsService.showError(t("ktu1m1u1sdi"));
        }
    }
};

export default UserApi;
